import React from 'react';
import PropTypes from 'prop-types';
import {
  PaymentTabContainer,
  StyledPaymentTabText,
  StyledSummaryTabText,
  SummaryTabContainer,
} from './PaymentMethodDefaultDetails.styled';

/**
 * Displays the details for the default payment method.
 *
 * @property {boolean} isDefault - Indicates if the payment method is set as default.
 * @property {boolean} isSummaryPage - Indicates if the component is rendered on the summary page.
 * @property {string} nextInvoiceDate - The date of the next invoice.
 */
const PaymentMethodDefaultDetails = ({
  isDefault,
  isSummaryPage,
  nextInvoiceDate,
}) => {
  /**
   * Determines if the component to render is for the summary page or the payment tab.
   */
  const Container = isSummaryPage ? SummaryTabContainer : PaymentTabContainer;

  /**
   * Determines the styled typography component is for the summary page or the payment tab.
   */
  const StyledTypography = isSummaryPage
    ? StyledSummaryTabText
    : StyledPaymentTabText;

  /**
   * If payment method is not default, details are not displayed.
   */
  if (!isDefault) {
    return null;
  }
  return (
    <Container data-testid="BillingLicensing-PaymentMethodDefaultDetails">
      <StyledTypography data-testid="BillingLicensing-PaymentMethodDefaultDetails-DefaultText">
        This is your default payment method
      </StyledTypography>
      {!isSummaryPage && (
        <p data-testid="BillingLicensing-PaymentMethodDefaultDetails-NextInvoice">
          Next invoice on {nextInvoiceDate}
        </p>
      )}
    </Container>
  );
};

PaymentMethodDefaultDetails.propTypes = {
  isDefault: PropTypes.bool.isRequired,
  isSummaryPage: PropTypes.bool.isRequired,
  nextInvoiceDate: PropTypes.string.isRequired,
};

export default PaymentMethodDefaultDetails;
